function setNavToggle() {
	document.addEventListener("DOMContentLoaded", function () {
		var hamburger = document.querySelector(".block-navigation__hamburger");

		if (hamburger) {
			hamburger.addEventListener("click", function () {
				this.classList.toggle("active");
			});
		}
	});
}
document.addEventListener("DOMContentLoaded", function () {
	const menuLinks = document.querySelectorAll(".menu-item-has-children > a");
  
	menuLinks.forEach(link => {
	  link.addEventListener("click", function (e) {
		const parentLi = this.parentElement;
  
		// Only for mobile
		if (window.innerWidth < 992) {
		  e.preventDefault();
  
		  // Close all other submenus
		  document.querySelectorAll(".menu-item-has-children.open").forEach(item => {
			if (item !== parentLi) {
			  item.classList.remove("open");
			}
		  });
  
		  // Toggle this one
		  parentLi.classList.toggle("open");
		}
	  });
	});
  });  

setNavToggle();
